import VulnerabilityDetailsInfo from './VulnerabililtyDetailsInfo';

export default VulnerabilityDetailsInfo;
export { VulnerabilityDetailsInfo };
